import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { i18nTranslate, application } from 'src/utils'
import { setupFocusTrap } from 'src/utils/focusTrap'
import { Button, Row, Col } from 'react-bootstrap'
import { Modal } from 'react-bootstrap'
import graphicBanner from 'src/images/Graphic.svg'
import stellaIcon from 'src/images/stela_logo_stacked.svg'
import { Icons, toastState } from 'src/views/components'
import TagManager from 'react-gtm-module'
import { productDeps } from 'src/deps/ProductDeps'
import { defaultSocialShare } from './fixture'
import './styles.scss'

@observer
class CreateQuickshareLink extends React.Component {
  modalRef = React.createRef()
  removeFocusTrap = null
  @observable showSocialShare = false

  shareURL = this.props?.url || ''

  constructor(props) {
    super(props)
  }

  componentDidMount() {
    if (this.props.showModal && this.modalRef.current) {
      this.removeFocusTrap = setupFocusTrap(this.modalRef.current)
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.showModal && this.props.showModal && this.modalRef.current) {
      this.removeFocusTrap = setupFocusTrap(this.modalRef.current)
    }
    if (prevProps.showModal && !this.props.showModal && this.removeFocusTrap) {
      this.removeFocusTrap()
      this.removeFocusTrap = null
    }
  }

  componentWillUnmount() {
    if (this.removeFocusTrap) {
      this.removeFocusTrap()
      this.removeFocusTrap = null
    }
  }

  trackShareGTM = (url, sharedTo) => {
    const { product = {} } = this.props
    const dataLayerParams = {
      event: sharedTo === 'copytoClipboard' ? 'copytoClipboard' : 'quickshare',
      name: product?.name || '',
      id: product?.skuId || product?.productId || '',
      price: productDeps?.getUnitValue(this.props)?.priceAfterDiscount || 0,
      category: product?.categoryId || '',
      variant: product?.skuSelected?.variantLabel || '',
      quantity: '1',
      brand: product?.brand || '',
      platform: 'equinox',
      link_url: url || '',
    }
    if (sharedTo !== 'copytoClipboard') {
      dataLayerParams.sharedTo = sharedTo || ''
    }
    TagManager.dataLayer({
      dataLayer: {
        ...dataLayerParams,
      },
    })
  }

  handleCopyToClipboard = () => {
    navigator?.clipboard?.writeText(this.shareURL)
    toastState.setToastMessage(
      i18nTranslate('copied_to_clipboard_message', 'Link copied successfully'),
      true
    )
    this.trackShareGTM(this.shareURL, 'copytoClipboard')
  }

  handleShare = async () => {
    const quickShareDetail = {
      url: this.shareURL,
    }
    if (application.isDesktop) {
      // toggle social share menu
      this.showSocialShare = !this.showSocialShare
      if (this.showSocialShare && this.modalRef.current) {
   
        if (this.removeFocusTrap) {
          this.removeFocusTrap()
          this.removeFocusTrap = null
        }
        setTimeout(() => {
          const prevActive = document.activeElement

          if (this.removeFocusTrap) {
            this.removeFocusTrap()
            this.removeFocusTrap = null
          }
          this.removeFocusTrap = setupFocusTrap(this.modalRef.current)
          try {
            if (prevActive && typeof prevActive.focus === 'function') prevActive.focus()
          } catch (e) {
  
          }
        }, 0)
      }
    } else if (navigator.share) {
      try {
        await navigator.share(quickShareDetail)
        this.trackShareGTM(this.shareURL)
      } catch (error) {
        console.log(`Oops! Unable to share a link because: ${error}`)
      }
    }
  }

  renderSocialShare = () => {
    const socialShare =
      window?.social_share ||
      window?.translationResources?.social_share ||
      defaultSocialShare
    const imgUrlPdp =
      this.props?.product?.primaryimage || this.props?.product?.imageURL || ''

    const handleShareClick = item => {
      this.trackShareGTM(this.shareURL, item?.link?.title)
      window
        .open(
          item?.link?.href
            ?.replace('%url%', this.shareURL)
            ?.replace('%imgurl%', imgUrlPdp),
          '_blank'
        )
        .focus()
    }

    const handleKeyDown = (event, item) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault()
        handleShareClick(item)
      }
    }

    return (
      <div className="social-share-container">
        {socialShare?.map(
          (item, idx) =>
            item?.link?.title &&
            item?.link?.href && (
              <Row
                key={item.link.title + idx}
                tabIndex={0}
                className={`social-share-item social-${item?.link?.title?.toLowerCase()} m-0`}
                onClick={() => handleShareClick(item)}
                onKeyDown={event => handleKeyDown(event, item)}
                aria-label={`Share via ${item?.link?.title}`}
                style={{ cursor: 'pointer' }}>
                <Row className="m-0">
                  {item?.icon?.[0]?.derivatives?.webImage ? (
                    <Col lg={4} md={4} sm={4}>
                      <img
                        aria-hidden="true"
                        src={`${item.icon[0].derivatives.webImage}`}
                        alt={`${item?.link?.title} icon`}
                      />
                    </Col>
                  ) : (
                    <Col lg={4} md={4} sm={4}>
                      <Icons
                        name="product-icon"
                        icontype={'quickshare-icon'}
                        width="24px"
                        height="25px"
                        viewBox="0 0 24 25"
                        color="#000"
                        className="create-quickshare-link-share-icon"
                        aria-hidden="true"
                      />
                    </Col>
                  )}
                  <Col lg={8} md={8} sm={8}>
                    {item?.link?.title}
                  </Col>
                </Row>
              </Row>
            )
        )}
      </div>
    )
  }

  render() {
    const { showModal, onClose } = this.props
    const iconType = 'quickshare-icon'
    return (
      <Modal
        show={showModal}
        className={`${!application.isDesktop ? 'create-quickshare-mob-container' : ''}`}>
        <div ref={this.modalRef}>
          <Modal.Header
            closeButton
            className="create-quickshare-link-modal-header"
            onClick={onClose}>
            <Modal.Title className="create-quickshare-link-heading">
              {i18nTranslate('quick_share', 'Quickshare', {
                nameSpace: 'ssr-resource',
              })}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="create-quickshare-link-body">
            <h1 tabIndex={0} className="create-quickshare-ready-text">
              {i18nTranslate('offer_complete', 'Your share link is ready!', {
                nameSpace: 'ssr-resource',
              })}
            </h1>
            <p className="create-quickshare-link-text">
              {i18nTranslate(
                'offer_complete_desc',
                'Share this link with friends and get rewarded when they make a purchase using it.',
                {
                  nameSpace: 'ssr-resource',
                }
              )}
            </p>
            <img
              className="create-quickshare-graphic-banner"
              src={graphicBanner}
              alt="graphicBanner"
            />
            <div className="create-quickshare-link-title">
              {i18nTranslate('share_link', 'Share link:', {
                nameSpace: 'ssr-resource',
              })}
            </div>
            <div className="create-quickshare-link">
              <a
                className="create-quickshare-link picker-disabled"
                href={this.shareURL}>
                {this.shareURL}
              </a>
            </div>
          </Modal.Body>

          <Modal.Footer className="create-quickshare-link-footer">
            <div className="create-quickshare-link-stella">
              <img
                className="create-quickshare-link-stella-icon"
                src={stellaIcon}
                alt="stellaIcon"
              />
              <div>
                <p className="create-quickshare-link-stella-title">
                  {i18nTranslate(
                    'link_performance_prompt',
                    'Want to see how this link performs?',
                    {
                      nameSpace: 'ssr-resource',
                    }
                  )}
                </p>
                <p className="create-quickshare-link-stella-body">
                  {i18nTranslate(
                    'performance_data_info',
                    'Performance data can be viewed on the Product Offer page in your Stela app.',
                    {
                      nameSpace: 'ssr-resource',
                    }
                  )}
                </p>
              </div>
            </div>
            <div className="create-quickshare-link-footer-border"></div>
            <div className="create-quickshare-link-footer-button position-relative">
              <Button
                className="copy-clipboard-btn-outline-primary"
                onClick={this.handleCopyToClipboard}>
                {i18nTranslate('copy_link', 'Copy to Clipboard', {
                  nameSpace: 'ssr-resource',
                })}
              </Button>
              <Button
                className="share-btn-outline-primary"
                onClick={this.handleShare}>
                <Icons
                  name="product-icon"
                  icontype={iconType}
                  width="24px"
                  height="25px"
                  viewBox="0 0 24 25"
                  color="#ffffff"
                  className="create-quickshare-link-share-icon"
                />
                {i18nTranslate('share', 'Share', {
                  nameSpace: 'ssr-resource',
                })}
              </Button>
              {this.showSocialShare && this.renderSocialShare()}
            </div>
          </Modal.Footer>
        </div>
      </Modal>
    )
  }
}

export { CreateQuickshareLink }
export default CreateQuickshareLink
